module.exports = __webpack_public_path__ + "img/22_BC23_friend_ship.5faba0b3.jpg";